<template>
  <div class="crad-bg">
    <p>账户余额：</p>
    <p>
      <span style="font-size: 40px" :class="[balance < 100 ? 'red' : '']">{{
        balance
      }}</span
      >元
    </p>
    <div>
      <div class="ps">注：账户余额可用于购买任意类型工资条，充值送工资条。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    balance: Number,
  },
  components: {},
  data() {
    return {
      isCospla: true,
    }
  },
  methods: {},
  mounted() {},
}
</script>

<style lang="less" scoped>
.red {
  color: red;
}
.title-contact {
  font-size: 16px;
  float: right;
  line-height: 30px;
}
.crad-bg {
  padding: 25px 35px;
  background: url('../assets/card.png') no-repeat;
  background-size: 100%;
  background-position: -10px 0px;
  color: #fff;
  width: 400px;
  p {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 25px;
  }
  > div {
    display: flex;
    .ps {
      width: 60%;
    }
    .recharge {
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        cursor: pointer;
        width: 84px;
        text-align: center;
        line-height: 38px;
        height: 38px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 26px;
        border: 1px solid rgba(255, 255, 255, 0.5);
      }
    }
  }
}
</style>
